import React from "react";
import iconMusic from "../../img/icons-ext-file/iconMusic.png"

export default function FileMusic() {
    return (
        <img src={iconMusic} alt="" />
    );
}